// extracted by mini-css-extract-plugin
export default {"aboutText":"UserSupport_aboutText__sStSZ","about":"UserSupport_about__f+Zhc"};